<template>
  <div class="search-item-container search-item-instagram">
    <!-- HEADER -->
    <div class="search-item-header">
      <div class="search-item-title">
        <h4>
          <a :href="item.liveUrl" target="_blank">{{
            item.metaData.instagramCaption
          }}</a>
        </h4>
      </div>
      <div class="search-item-link">
        <a :href="item.liveUrl" target="_blank">{{ item.displayUrl }}</a>
      </div>
      <div class="search-item-header-date">
        {{ item.date }}
      </div>
    </div>

    <!-- CONTENT -->
    <div class="search-item-content">
      <a :href="item.liveUrl" target="_blank">
        <img
          :src="item.metaData.instagramMediaUrl"
          :alt="'Thumbnail for ' + item.title"
          v-if="
            item.metaData &&
            item.metaData.instagramMediaType === 'IMAGE' &&
            item.metaData.instagramMediaUrl
          "
        />
        <img
          :src="item.metaData.instagramThumbnailUrl"
          :alt="'Thumbnail for ' + item.title"
          v-if="
            item.metaData &&
            item.metaData.instagramMediaType === 'VIDEO' &&
            item.metaData.instagramThumbnailUrl
          "
        />
      </a>
      <span class="search-item-date">{{ item.date }} </span
      ><span v-html="truncatedText"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchItemInstagram",
  computed: {
    collection() {
      return this.item.collection;
    },
    truncatedText() {
      if (
        this.item.metaData.instagramCaption &&
        this.item.metaData.instagramCaption.length > 440
      ) {
        return this.item.metaData.instagramCaption.substring(0, 440) + "...";
      } else {
        return this.item.metaData.instagramCaption;
      }
    },
  },
  props: {
    item: {
      type: Object,
    },
  },
};
</script>

<style scoped>
.search-item-instagram .search-item-header .search-item-title h4 {
  text-overflow: ellipsis;

  /* Required for text-overflow to do anything */
  white-space: nowrap;
  overflow: hidden;
}

.search-item .search-item-content img,
.search-item .search-item-content .search-item-image-wrapper {
  max-height: 230px;
  max-width: 230px;
}

@media only screen and (max-width: 450px) {
  .search-item .search-item-content img,
  .search-item .search-item-content .search-item-image-wrapper {
    max-height: unset;
    max-width: 100%;
    margin-left: 0;
    margin-bottom: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// searchItemInstagram.vue?1210ba04